(() => {
  'use strict';
  const tag = document.currentScript;
  if (!tag || window.JBSEOFeatureLoader) return;
  const features = [
    {selector: '.jb-artwork,[data-jb-category-motion]', url: tag.dataset.artworkSrc, loaded: false, candidates: []},
    {selector: '[data-jb-atelier]', url: tag.dataset.atelierSrc, loaded: false, candidates: []}
  ];
  window.JBSEOFeatureLoader = true;
  let queued = false;
  const visible = node => {
    const categoryMarker = node.matches('[data-jb-category-motion]');
    if (categoryMarker) node = node.parentElement;
    const ariaAncestor = categoryMarker ? node : node?.parentElement;
    if (!node || !node.isConnected || node.closest('[hidden],[inert]') || ariaAncestor?.closest('[aria-hidden="true"]')) return false;
    if (!node.getClientRects().length) return false;
    const style = getComputedStyle(node);
    return style.display !== 'none' && style.visibility !== 'hidden';
  };
  const load = feature => {
    if (feature.loaded || !feature.url) return;
    feature.loaded = true;
    const script = document.createElement('script');
    script.src = feature.url;
    script.async = true;
    script.dataset.jbSeoFeature = feature.selector;
    script.addEventListener('error', () => { feature.loaded = false; script.remove(); }, {once: true});
    document.head.append(script);
  };
  const inspect = () => {
    queued = false;
    for (const feature of features) {
      if (feature.loaded) continue;
      feature.candidates = feature.candidates.filter(node => node.isConnected);
      if (feature.candidates.some(visible)) load(feature);
    }
  };
  const schedule = () => {
    if (queued || features.every(feature => feature.loaded)) return;
    queued = true;
    requestAnimationFrame(inspect);
  };
  const start = () => {
    const discover = () => {
      for (const feature of features) if (!feature.loaded) feature.candidates = [...document.querySelectorAll(feature.selector)];
    };
    discover();
    inspect();
    const observer = new MutationObserver(records => {
      if (features.every(feature => feature.loaded)) { observer.disconnect(); return; }
      if (records.some(record => record.type === 'childList' && record.addedNodes.length)) discover();
      const relevant = records.some(record => record.type === 'childList' || features.some(feature => !feature.loaded && feature.candidates.some(node => record.target === node || record.target.contains(node))));
      if (relevant) schedule();
    });
    observer.observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['hidden','inert','aria-hidden','class','style']});
    document.addEventListener('shopify:section:load', () => { discover(); schedule(); });
    window.addEventListener('pageshow', schedule);
    document.addEventListener('visibilitychange', schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
